import { render, staticRenderFns } from "./BaseCardBody.vue?vue&type=template&id=53ce3d28"
import script from "./BaseCardBody.vue?vue&type=script&lang=js"
export * from "./BaseCardBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports